module.exports = __webpack_public_path__ + "static/media/big-check-icon.9c07e1e7.svg";